// extracted by mini-css-extract-plugin
export default {"dialog":"default_dialog__wVh5E","controls":"default_controls__vVjqd"};